module.exports = __webpack_public_path__ + "../assets/img/85fb8703f8af7bb90fac9f2663929c4c.svg";